/* oxlint-disable typescript/no-unnecessary-condition -- runtime safety for test environments */
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';

// backendUrlsTable can be undefined at runtime when environment variables are not available
// (e.g., in unit tests without DOM/meta tags), even though TypeScript types say otherwise
const { backendUrlsTable, frontendUrlsTable } = getUrlsTable(getEnvironmentVariables());

export const apiBaseURL = backendUrlsTable?.apiBaseURL ?? '';
export const authBaseURL = backendUrlsTable?.authBaseURL ?? '';
export const registerBaseURL = backendUrlsTable?.registerBaseURL ?? '';
export const registerPartnersBaseURL = backendUrlsTable?.registerPartnersBaseURL ?? '';
export const billerBaseURL = backendUrlsTable?.billerBaseURL ?? '';
export const notifierBaseURL = backendUrlsTable?.notifierBaseURL ?? '';
export const companyCreationBaseURL = backendUrlsTable?.companyCreationBaseURL ?? '';
export const cookieDomain = backendUrlsTable?.cookieDomain ?? '';

// API namespaces
export const BILLER_V2_NAMESPACE = 'v2';
export const billerV3Namespace = 'v3';
export const billerV4Namespace = 'v4';
export const billerNamespace = 'v1';
export const organizationNamespace = 'v3';
export const cardAcquirerNamespace = 'card_acquirer/v1';
export const insuranceHubNamespace = 'v1';
export const notifierNamespace = 'v1';
export const registerNamespace = 'v1';
export const registerPartnersNamespace = 'client_api';
export const upcomingTransactionsNamespaceV2 = 'v2';
export const upcomingTransactionsNamespaceV3 = 'v3';
export const paymentLinkV2Namespace = 'payment_links/v2';
export const paymentLinkV4Namespace = 'payment_links/v4';
export const mollieV2Namespace = 'payment_links/v2/mollie';
export const supplierInvoiceNamespace = 'v1';
export const supplierHubNamespace = `${supplierInvoiceNamespace}/supplier_invoices`;
export const receivableInvoiceNamespace = 'v5';
export const shortcutsNamespace = 'v1';
export const conversationsNamespace = 'v1';
export const notificationsNamespace = 'v1';

// Frontend URLs
export const appJsURL = frontendUrlsTable?.appJsURL ?? '';
export const companyCreationJsURL = frontendUrlsTable?.companyCreationJsURL ?? '';
export const registerJsURL = frontendUrlsTable?.registerJsURL ?? '';
export const registerPartnersJsURL = frontendUrlsTable?.registerPartnersJsURL ?? '';
export const embedOnboardingURL = frontendUrlsTable?.embedOnboardingURL ?? '';
export const receivableInvoicesURL = frontendUrlsTable?.receivableInvoicesURL ?? '';
